
import React, { useEffect, useState } from 'react'
import { Button, Typography, Divider, Flex, Tag, Drawer, Radio, Space } from 'antd'
import {LeftOutlined ,WechatOutlined,PhoneOutlined,VideoCameraOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'

const { Title, Text, Link } = Typography;

const TopBar = (props) => {
 const {title="N/A"} = props;
 const navigate = useNavigate();

  return (


      <Flex align="center" style={{backgroundColor:"#FFF3F2", padding:"10px 12px",borderBottom:"3px solid #DF7467"}}>
        <Button onClick={()=>{navigate(-1)}} type="text" size="small" icon={<LeftOutlined />} />
        <Title style={{padding:0, margin:0}} level={5}>{title}</Title>
      </Flex>


  )
};

export default TopBar;
